<template>
    <!-- 询盘查看及分析数量趋势 -->
    <div class="col-chart-box">
        <div class="col-chart-head line">
            <div class="left">
                <div class="left-title">询盘查看及报价数量趋势</div>
                <el-popover 
                    placement="right"
                    trigger="hover"
                    width="300"
                >
                    <div>
                        <p>查看询盘次数：查看全部询盘总次数</p>
                        <p>报价次数：报价次数，同一询盘多次报价重复计.（不含草稿、已撤回、已撤销报价）</p>
                    </div>
                    <i slot="reference" class="iconfont icon-icon-zhuming2"></i>
                </el-popover>
            </div>
            <!-- <div class="right">
                <ul>
                    <li 
                        v-for="(item, i) in timeTabList" 
                        @click="changeTimeTab(i, item.code)" 
                        :class="{'active': timeTab == i}"
                        :key="i"
                    >{{item.label}}</li>
                </ul>
            </div> -->
        </div>
        <div v-loading="loading" class="col-chart-view" style="display: flex;justify-content: center;">
            <div ref="echart" style="height: 258px; width:100%;"></div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import windowAddEvent from '@/utils/windowAddEvents';
import {  getDataAssistant } from "@/utils/api/dashboard";

export default  {
    data(){
        return {
            echartsObj:  '',
            inquiryViewData:{},
            loading:false
        }
    },
    methods:{
        //获取数据
        getInquiryViewData(){
            this.loading =true;
            const params = {
                startDate: moment(new Date().setMonth(new Date().getMonth()-6)).format('YYYY-MM-DD'),
                endDate: moment().format('YYYY-MM-DD'),
                enums:['CLICK_RFQ_NUM','QUOTE_NUM']
            }
            getDataAssistant(params)
            .then((res)=>{
                const bizCode = res.rspResult.bizCode;
                const codeArr = [401, 403, 404];
                if(bizCode === 200){
                    this.inquiryViewData = res.data;
                    this.addListData();
                    this.loading = false;
                }else if (!codeArr.includes(bizCode)) {
                    this.loading = false;
                    this.$message.error(res.data.rspResult.message);
                }
            })
            .catch((err)=>{
                this.loading = false;
                this.$message.error("System error",err);
            })
        },
    
        init(currentData) {
            let interval= 15;
            let options = {
                tooltip: {
                    trigger: "axis"
                },
                legend: {
                    left: '20',
                    top: '19',
                    itemWidth: 14,
                    itemHeight: 7,
                    textStyle: {
                        color: "#666",
                        fontSize: 12,
                        fontFamily: "PingFangSC-Regular",
                        lineHeight: 17
                    },
                    icon: "path://M899.5 458.3c-19.7 0-35.7 16-35.7 35.7 0 84.4-68.6 153-153 153s-153-68.6-153-153c0-0.3-0.1-0.5-0.1-0.7-1.7-122.4-101.6-221.5-224.3-221.5-123.7 0-224.4 100.7-224.4 224.4 0 19.7 16 35.7 35.7 35.7s35.7-16 35.7-35.7c0-84.4 68.6-153 153-153s153 68.6 153 153c0 0.3 0.1 0.5 0.1 0.7 1.6 122.4 101.5 221.5 224.3 221.5 123.7 0 224.4-100.7 224.4-224.4 0-19.7-16-35.7-35.7-35.7z"
                },
                grid: {
                    left: 45,
                    right: 32,
                    bottom: 58,
                },
               
                xAxis: {
                    type: "category",
                    boundaryGap: true,
                    axisTick: {
                        alignWithLabel: true
                    },
                    axisLine: {
                        lineStyle: {
                            color: "#ccc"
                        }
                    },
                    axisLabel: {
                        interval,
                        rotate: 50,
                        margin: 10,
                        color: "#666",
                        fontSize: 10,
                        fontFamily: "PingFangSC-Medium",
                        lineHeight: 17
                    },
                    data: currentData.x
                },
                yAxis: {
                    type: "value",
                    axisLine: {
                        lineStyle: {
                            color: "#ccc"
                        }
                    },
                    axisLabel: {
                        formatter: (value, index)=> {
                            if(value.toString().indexOf('.') > -1) {
                                return "";
                            }
                            return value;
                        }
                    }
                },
                series: [
                    {
                        name: "查看询盘次数",
                        type: "line",
                        symbol: "emptyCircle",
                        smooth: true,
                        lineStyle: {
                            width: 1,
                            color: "#FFAE44"
                        },
                        itemStyle: {
                            color: "#FFAE44"
                        },
                        data: currentData.xpData,
                        // encode: {x: 2, y: 3}
                    },
                    // 数据格式为这种数组，可以构造
                    {
                        name: "报价次数",
                        type: "line",
                        symbol: "emptyCircle",
                        smooth: true,
                        lineStyle: {
                            width: 1,
                            color: "#12C5D9"
                        },
                        itemStyle: {
                            color: "#12C5D9"
                        },
                        // encode: {x: 0, y: 1},
                        data: currentData.bjData,
                    }
                    
                ]
            };
            this.echartsObj.clear();
            this.echartsObj.setOption(options);
        },
    
        handleListData(data) {
            let {bjCount, xpCount} = data;
            let x=  [];
            let bjData= bjCount.map((item) => {
                x.push(item.title );
                return item.num;
            });
            let xpData=  xpCount.map((item) => {
                return item.num;
            });
            return {
                x,
                bjData,
                xpData
            };
        },
    
        addListData() {
            let resultData=
                {
                    bjCount: this.inquiryViewData.quoteNum,
                    xpCount: this.inquiryViewData.clickRfqNum
                }
            const handledData = this.handleListData(resultData)
            this.init(handledData)
        },
       
    },
    mounted() {
        this.getInquiryViewData()
        let ele = this.$refs.echart;
        this.echartsObj = this.$echarts.init(ele);
        windowAddEvent('resize', this.echartsObj.resize);
    },

}
</script>

<style lang="scss" >

</style>